import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';
import type { OfferFormState, OfferTypesType } from '../types/offer.types';

export interface OfferFormContextValue {
  offerType: OfferTypesType;
  offerForm: OfferFormState;
  setOfferType: (type: OfferTypesType) => void;
  setOfferForm: Dispatch<SetStateAction<OfferFormState>>;
  resetForm: () => void;
}

export const OfferFormContext = createContext<OfferFormContextValue | undefined>(undefined);

export const useOfferFormContext = (): OfferFormContextValue => {
  const context = useContext(OfferFormContext);
  if (!context) {
    throw new Error('useOfferFormContext must be used within OfferFormProvider');
  }
  return context;
};
